import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../api";

export const doGetAllPartners = createAsyncThunk("partners/doGetAllPartners", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doGetAllPartners(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreatePartner = createAsyncThunk("partners/doCreatePartner", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doCreatePartner(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdatePartner = createAsyncThunk("partners/doUpdatePartner", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUpdatePartner(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});
